export default "__VITE_ASSET__DLfNgxCC__"